module.exports = __webpack_public_path__ + "img/TideHunter.f2c68d39.png";